/* eslint-disable @wordpress/dependency-group */
export default function createButtonUp(parentEl, siteFooter) {
	const topUp = document.createElement('button');
	topUp.className = 'top-up';
	topUp.setAttribute('rel', 'top-up');
	topUp.setAttribute('type', 'button');
	// menuBubble.style.opacity = 0;
	parentEl.insertBefore(topUp, siteFooter);
}
